import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { API_URL } from "../../config";
import SweetAlert from "react-bootstrap-sweetalert";
import { useAppContext } from "../../Lib/ContextLib";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import moment from "moment";
import Select from "react-select";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const filterSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: "12px",
    border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
    boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.1)" : "none",
    height: "48px",
    fontSize: "0.95rem",
    backgroundColor: "#ffffff",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected 
      ? "#ffc107" 
      : state.isFocused 
      ? "rgba(255, 193, 7, 0.1)" 
      : "#fff",
    color: state.isSelected ? "#000" : "#1e293b",
    padding: "10px 15px",
    cursor: "pointer",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    border: "1px solid #e2e8f0",
    zIndex: 9999,
  }),
};

export default function Home({ rowValue }) {
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [alert, setAlert] = React.useState(null);
  const [loader, setLoader] = React.useState(false);
  const [dataCheck, setDataCheck] = React.useState(false);
  const [filteredOptions, setFilteredOptions] = React.useState();

  const { setShowPage } = useAppContext();
  const { socket } = useAppContext();

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success("Copied to clipboard!");
  };

  

  React.useEffect(() => {
    if (rowValue) {
      if (!dataCheck) {
        setLoader(true);
        setTimeout(() => {
          setFilteredOptions(rowValue);
          setDataCheck(true);
          setLoader(false);
        }, 1000);
      }
    }
  }, [rowValue, filteredOptions]);

  const homeSchema = Yup.object().shape({
    playerStatus: Yup.string().required("required"),
  });

  const successEditStatus = (msg) => {
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={<h4>{msg}</h4>}
        onConfirm={() => {
          setAlert(null);
          setButtonLoader(false);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  return (
    <div>
      {alert}
      {!loader && (
        <Formik
          initialValues={{
            playerId: rowValue ? rowValue?.playerId : "",
            email: rowValue ? rowValue?.email : "",
            phoneNo: rowValue ? rowValue?.phoneNo : "",
            userName: rowValue ? rowValue?.userName : "",
            dob: rowValue ? rowValue?.dob : "",
            gender: rowValue ? rowValue?.gender : "",
            name: rowValue ? rowValue?.name : "",
            image: rowValue ? rowValue?.image : "",
            balance: rowValue ? rowValue?.balance : "",
            depositeBalance: rowValue ? rowValue?.depositeBalance : "",
            withdrawBalance: rowValue ? rowValue?.withdrawBalance : "",
            bonusBalance: rowValue ? rowValue?.bonusBalance : "",
            date: rowValue ? rowValue?.date : "",
            daily_time: rowValue ? rowValue?.daily_time : "",
            spin_time: rowValue ? rowValue?.spin_time : "",
            day_no: rowValue ? rowValue?.day_no : "",
            combo_no: rowValue ? rowValue?.combo_no : "",
            isTermCondition: rowValue ? rowValue?.isTermCondition : "",
            playerStatus: rowValue ? rowValue?.playerStatus : 0,
          }}
          validationSchema={homeSchema}
          onSubmit={(values, { resetForm }) => {
            setButtonLoader(true);
            const data = {
              playerStatus: values.playerStatus,
            };
            axios
              .patch(
                `${API_URL}/api/admin/player/update-player-status/${rowValue._id}`,
                data
              )
              .then((result) => {
                const data = {
                  playerId: rowValue.playerId,
                  message: "Change Status",
                };
                if (result.data.status) {
                  socket.emit("PlayerDetailsUpdate", data);
                  successEditStatus(result.data.message);
                  resetForm();
                } else {
                  toast("Error...");
                  setButtonLoader(false);
                  resetForm();
                }
              })
              .catch((err) => {
                setButtonLoader(true);
                console.log("handleSubmit err :::", err);
              });
          }}
        >
          {({ touched, errors, isSubmitting, values, setFieldValue }) => (
            <div>
              <Form className="premium-form-container">
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="form-group premium-field">
                      <label htmlFor="playerId">Player Id</label>
                      <div className="position-relative">
                        <Field
                          disabled
                          type="text"
                          name="playerId"
                          className="form-control premium-input disabled-bg pr-5"
                        />
                        <div 
                          className="position-absolute courser" 
                          style={{ right: '15px', top: '50%', transform: 'translateY(-50%)', color: '#64748b' }}
                          onClick={() => handleCopy(rowValue?.playerId)}
                        >
                          <ContentCopyIcon style={{ fontSize: '18px' }} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group premium-field">
                      <label htmlFor="email">Email Address</label>
                      <Field
                        disabled
                        type="text"
                        name="email"
                        className="form-control premium-input disabled-bg"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group premium-field">
                      <label htmlFor="phoneNo">Phone Number</label>
                      <Field
                        disabled
                        type="text"
                        name="phoneNo"
                        className="form-control premium-input disabled-bg"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group premium-field">
                      <label htmlFor="userName">Username</label>
                      <Field
                        disabled
                        type="text"
                        name="userName"
                        className="form-control premium-input disabled-bg"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group premium-field">
                      <label htmlFor="name">Display Name</label>
                      <Field
                        disabled
                        type="text"
                        name="name"
                        className="form-control premium-input disabled-bg"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group premium-field">
                      <label htmlFor="dob">Date of Birth</label>
                      <Field
                        disabled
                        type="text"
                        name="dob"
                        value={rowValue?.dob ? moment(rowValue.dob).format("DD/MM/YYYY") : ""}
                        className="form-control premium-input disabled-bg"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group premium-field">
                      <label htmlFor="gender">Gender</label>
                      <Field
                        disabled
                        type="text"
                        name="gender"
                        className="form-control premium-input disabled-bg"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group premium-field">
                      <label htmlFor="balance">Current Balance</label>
                      <Field
                        disabled
                        type="text"
                        name="balance"
                        className="form-control premium-input disabled-bg font-weight-bold"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group premium-field">
                      <label htmlFor="depositeBalance">Deposit Balance</label>
                      <Field
                        disabled
                        type="text"
                        name="depositeBalance"
                        className="form-control premium-input disabled-bg"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group premium-field">
                      <label htmlFor="withdrawBalance">Withdrawal Balance</label>
                      <Field
                        disabled
                        type="text"
                        name="withdrawBalance"
                        className="form-control premium-input disabled-bg"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group premium-field">
                      <label htmlFor="bonusBalance">Bonus Balance</label>
                      <Field
                        disabled
                        type="text"
                        name="bonusBalance"
                        className="form-control premium-input disabled-bg"
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="divider mt-4 mb-4">
                      <span className="bg-white px-3 text-muted small font-weight-bold text-uppercase">Account Security</span>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group premium-field">
                      <label htmlFor="playerStatus">Account Status</label>
                      <Select
                        styles={filterSelectStyles}
                        options={[
                          { value: 0, label: "Active" },
                          { value: 1, label: "Banned" },
                          { value: 2, label: "Delete" },
                        ]}
                        value={[
                          { value: 0, label: "Active" },
                          { value: 1, label: "Banned" },
                          { value: 2, label: "Delete" },
                        ].find(opt => opt.value === parseInt(values.playerStatus))}
                        onChange={(option) => setFieldValue("playerStatus", option.value)}
                      />
                      <ErrorMessage component="div" name="playerStatus" className="invalid-feedback" />
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-5">
                  <button
                    type="submit"
                    className="btn btn-primary premium-submit-btn"
                    disabled={buttonLoader}
                    style={{ minWidth: '150px' }}
                  >
                    {buttonLoader ? (
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="spinner-border spinner-border-sm mr-2"></span>
                        Updating...
                      </div>
                    ) : (
                      <b>Update Status</b>
                    )}
                  </button>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      )}
      <div className="mt-4">{loader && <Loader />}</div>
    </div>
  );
}
